<template>
  <div class="excelContent">
    <!-- <div id="luckysheet" style="position: absolute; margin: 0px; padding: 0px; width: calc(100% -100px); height: 654px; z-index: 10000"></div> -->
    <div id="luckysheet" class="luckysheet-content"></div>
    <div class="header">
      <!-- 本地导入 -->
      <Button type="primary" size="default" style="margin-left: 20px" @click="Back">返回</Button>
      <Button type="primary" size="default" style="margin-left: 20px" @click="isShowSaveExcel = true" v-if="bomStatus !== $constDefinition.done && status !== 3">保存</Button>
      <Button type="primary" size="default" style="margin-left: 20px" @click="isShowSubmitExcel = true" v-if="(bomStatus === $constDefinition.submitingTable || bomStatus === $constDefinition.generatingTable) && status !== 3">提交</Button>
      <Button type="primary" size="default" style="margin-left: 20px" @click="isShowDoneExcel = true" v-if="bomStatus === $constDefinition.submitedTable && status !== 3">结束</Button>
    </div>
    <Modal v-model="isShowSaveExcel" :mask-closable="false" class="modal-cont">
      <p class="content">确认保存吗？</p>
      <div slot="footer" class="footer">
        <Button @click="isShowSaveExcel = false">取消</Button>
        <Button type="primary" @click="saveExcel">确认</Button>
      </div>
    </Modal>
    <Modal v-model="isShowSubmitExcel" :mask-closable="false" class="modal-cont">
      <p class="content">确认提交吗？</p>
      <div slot="footer" class="footer">
        <Button @click="isShowSubmitExcel = false">取消</Button>
        <Button type="primary" @click="submitExcel">确认</Button>
      </div>
    </Modal>
    <Modal v-model="isShowDoneExcel" :mask-closable="false" class="modal-cont">
      <p class="content">确认结束管制表吗？</p>
      <div slot="footer" class="footer">
        <Button @click="isShowDoneExcel = false">取消</Button>
        <Button type="primary" @click="doneExcel">确认</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import moment from 'moment'
import ajax from '../../../lib/ajax'
export default {
  name: 'excel',
  data() {
    return {
      celldata: [],
      options: {
        container: 'luckysheet',
        title: '', // 表头名
        lang: 'zh', // 中文
        showtoolbar: false, // 是否显示工具栏
        showinfobar: false, // 是否显示顶部信息栏
        showsheetbar: false, // 是否显示底部sheet按钮
        sheetFormulaBar: false,
        showstatisticBar: false,
        showstatisticBarConfig: {
          count: false, // 计数栏
          view: false, // 打印视图
          zoom: false, // 缩放
        },
        row: 1,
        column: 1,
        defaultColWidth: 100,
        // columnHeaderHeight: 0,
        rowHeaderWidth: 0,
        enableAddRow: false,
        enableAddBackTop: false,
        hook: {
          cellMousedownBefore: function (cell, position, sheet, ctx) {
            // console.log(position);
            // if (position.c == 0) {
            // luckysheet.setRangeShow([`A${position.r + 1}:Z${position.r + 1}`]);
            // }
          },
          cellMousedown: function (cell, position, sheet, ctx) {
            // console.log(position);
            // if (position.c == 0) {
            // luckysheet.setRangeShow([`A${position.r + 1}:Z${position.r + 1}`]);
            // }
            // for (let i = 0; i < 31; i++) {
            //     luckysheet.setCellValue(position.r, i, {
            //         bg: '#fff',
            //     });
            // }
            // for (let i = 0; i < 31; i++) {
            //     luckysheet.setCellValue(position.r, i, {
            //         bg: '#ff1f1d',
            //     });
            // }
            // luckysheet.setRangeShow([{ row: [1, 2], column: [1, 2] }]);
            // luckysheet.setRangeShow([{ row: [position.r, position.r + 1] }]);
          },
          cellEditBefore: function (range) {
            // console.log(range[0].row_focus);
            // 一行高亮显示
            luckysheet.setRangeShow([`A${range[0].row_focus + 1}:AC${range[0].row_focus + 1}`])
          },

          cellUpdateBefore: function (r, c, value, isRefresh) {
            if (r === 0) {
              return false
            }
            if (c === 0) {
              return false
            }
            // if (c == 5) {
            //     if (isNaN(value)) {
            //         return false;
            //     }
            // }
            // if (c == 6) {
            //     if (isNaN(value)) {
            //         return false;
            //     }
            // }
            // if (c == 7) {
            //     if (isNaN(value)) {
            //         return false;
            //     }
            // }
            // if (c == 8) {
            //     if (isNaN(value)) {
            //         return false;
            //     }
            // }
            if (c === 29) {
              return false
            }
          },
          cellUpdated: async function (r, c, oldValue, newValue, isRefresh) {
            console.log(r, c)
            if (r === 0) {
              return false
            }
            if (c === 0) {
              return false
            }
            if (c === 29) {
              return false
            }
            if (c === 25) {
              await ajax
                .post(
                  `/api/services/app/BOMImportRecord/CalculateDelayDays?startTime=${
                    newValue.m ? newValue.m : ''
                  }&endTime=${luckysheet.getCellValue(r, 26) ? luckysheet.getCellValue(r, 26) : ''}`
                )
                .then((res) => {
                  luckysheet.setCellValue(r, 27, {
                    v: res.data.result,
                    fc: res.data.result > 0 ? '#ff1f1d' : '#438b3f',
                  })
                  // luckysheet.setCellValue(r, 27, res.data.result)
                })
            }
            if (c === 26) {
              ajax
                .post(
                  `/api/services/app/BOMImportRecord/CalculateDelayDays?startTime=${
                    luckysheet.getCellValue(r, 25) ? luckysheet.getCellValue(r, 25) : ''
                  }&endTime=${newValue.m ? newValue.m : ''}`
                )
                .then((res) => {
                  luckysheet.setCellValue(r, 27, {
                    v: res.data.result,
                    fc: res.data.result > 0 ? '#ff1f1d' : '#438b3f',
                  })
                  //   luckysheet.setCellValue(r, 27, res.data.result);
                })
            }
          },
        },
        cellRightClickConfig: {
          copy: false, // 复制
          copyAs: false, // 复制为
          paste: false, // 粘贴
          insertRow: false, // 插入行
          insertColumn: false, // 插入列
          deleteRow: false, // 删除选中行
          deleteColumn: false, // 删除选中列
          deleteCell: false, // 删除单元格
          hideRow: false, // 隐藏选中行和显示选中行
          hideColumn: false, // 隐藏选中列和显示选中列
          rowHeight: false, // 行高
          columnWidth: false, // 列宽
          clear: false, // 清除内容
          matrix: false, // 矩阵操作选区
          sort: false, // 排序选区
          filter: false, // 筛选选区
          chart: false, // 图表生成
          image: false, // 插入图片
          link: false, // 插入链接
          data: false, // 数据验证
          cellFormat: false, // 设置单元格格式
        },
      },
      isShowSaveExcel: false,
      isShowSubmitExcel: false,
      isShowDoneExcel: false,
    }
  },
  props: {
    id: Number,
    status: Number,
    cid: Number,
    bomStatus: Number,
  },
  mounted() {
    this.getInit()
  },
  activated() {
    // 判断是否取消过
    if (this.$store.state.purchase.cancel) {
      this.getInit()
      this.$store.dispatch({ type: 'purchase/setCancelData', data: false })
    }
  },
  methods: {
    async getInit() {
      this.$Spin.show()
      let result = []
      if (this.status == 1) {
        // 生成
        await this.$Ajax
          .post(`/api/services/app/BOMImportRecord/GenerateGZBData?id=${this.id}`)
          .then((res) => {
            result = res.data.result
          })
          .catch((err) => {
            if (err) {
              this.$Spin.hide()
              this.$emit('closeExcel', false)
              return
            }
          })
      } else if (this.status == 2) {
        // 修改
        await this.$Ajax
          .get(
            `/api/services/app/BOMImportRecord/GetGZBDataByBOMImportRecordId?bOMImportRecordId=${this.id}`
          )
          .then((res) => {
            result = res.data.result
          })
          .catch((err) => {
            if (err) {
              this.$Spin.hide()
              this.$emit('closeExcel', false)
              return
            }
          })
      } else if (this.status == 3 && this.cid) {
        //从操作日志来进行查看对比
        await this.$Ajax
          .get(
            `/api/services/app/BOMImportRecord/GetOldAndNewData?bOMImportRecordId=${this.id}&businessLogId=${this.cid}`
          )
          .then((res) => {
            result = this.diffData(res.data.result.newData, res.data.result.oldData)
            console.log('res', result)
          })
          .catch((err) => {
            if (err) {
              this.$Spin.hide()
              this.$emit('closeExcel', false)
              return
            }
          })
      }
      //转换成excel表需要的数据
      // this.diffData(新数据,老数据)
      this.celldata = this.formaterData(result)
      const data = [
        {
          name: '管制表',
          index: 1,
          status: 1,
          order: 0,
          celldata: this.celldata,
          config: {
            colhidden: {
              // '0':0
              29: 0,
              30: 0,
            },
            columnlen: {
              0: 40,
              1: 200,
              2: 200,
              3: 300,
              4: 140,
              5: 100,
              6: 100,
              7: 100,
              8: 100,
              9: 160,
              10: 80,
              11: 80,
              12: 80,
              13: 80,
              14: 80,
              15: 100,
              16: 100,
              17: 100,
              18: 100,
              19: 100,
              20: 100,
              21: 100,
              22: 100,
              23: 130,
              24: 120,
              25: 120,
              26: 120,
              27: 80,
              28: 80,
              29: 0,
              30: 0,
            },
            rowlen: {}, //行高
          },
          frozen: {
            type: 'both',
          },
          showGridLines: 1,
        },
      ]
      this.options.data = data
      window.luckysheet.create(this.options)
      this.$Spin.hide()
      //所属
      luckysheet.setDataVerification(
        {
          type: 'dropdown',
          type2: null,
          value1: '采购,外协',
          prohibitInput: true,
        },
        {
          range: 'R2:R4000',
        }
      )
      //类别1
      luckysheet.setDataVerification(
        {
          type: 'dropdown',
          type2: null,
          value1: '低值易耗,标准件,主材料,加工件,数控加工,五金工具,表面处理',
          prohibitInput: true,
        },
        {
          range: 'S2:S4000',
        }
      )
      //模具类型
      luckysheet.setDataVerification(
        {
          type: 'dropdown',
          type2: null,
          value1: '门吸,门发,门冲,箱吸,箱发,箱冲,无',
          prohibitInput: true,
        },
        {
          range: 'V2:V4000',
        }
      )
      //产线
      luckysheet.setDataVerification(
        {
          type: 'dropdown',
          type2: null,
          value1:
            'PDCPD,焊接结构件,幻音产品,摩泰克,冷模,热模,非标加工件,轮胎模具,汽车座椅模具,PDCPD制品,PDCPD模具,自动化',
          prohibitInput: true,
        },
        {
          range: 'X2:X4000',
        }
      )
      //设置高亮
      luckysheet.setRangeShow('B2')
    },
    async saveExcel() {
      let _this = this
      // 保存前将驯服的数据保存
      luckysheet.exitEditMode()
      let data = this.formaterSendData(window.luckysheet.getAllSheets()[0].celldata)
      console.log(data)
      this.$Spin.show()
      this.$Ajax
        .post(`/api/services/app/BOMImportRecord/SaveGZBData?bOMImportRecordId=${this.id}`, data)
        .then((res) => {
          this.isShowSaveExcel = false
          this.$Message.success({
            content: '保存成功',
          })
          this.$Spin.hide()
          if (this.status === 1 || this.bomStatus === this.$constDefinition.submitedTable) {
            window.luckysheet.destroy()
            _this.$emit('closeExcel', true)
          }
        })
        .catch((err) => {
          if (err) {
            this.isShowSaveExcel = false
            this.$Message.error({
              content: err,
            })
            this.$Spin.hide()
            return
          }
        })
      // 后台提供接口
      // 保存做的事情
    },
    async submitExcel() {
      let _this = this
      luckysheet.exitEditMode()
      let data = this.formaterSendData(window.luckysheet.getAllSheets()[0].celldata)
      // 后台提供接口
      //提交做的事情
      this.$Spin.show()
      this.$Ajax
        .post(`/api/services/app/BOMImportRecord/SubmitGZBData?bOMImportRecordId=${this.id}`, data)
        .then((res) => {
          this.$Message.success({
            content: '提交成功',
          })
          this.isShowSubmitExcel = false
          this.$Spin.hide()
          window.luckysheet.destroy()
          this.$emit('closeExcel', true)
        })
        .catch((err) => {
          if (err) {
            this.isShowSubmitExcel = false
            this.$Message.error({
              content: err,
            })
            this.$Spin.hide()
            return
          }
        })
    },
    // 结束
    async doneExcel() {
      let _this = this
      luckysheet.exitEditMode()
      let data = this.formaterSendData(window.luckysheet.getAllSheets()[0].celldata)
      this.$Spin.show()
      this.$Ajax
        .post(`/api/services/app/BOMImportRecord/FinishGZBData?bOMImportRecordId=${this.id}`, data)
        .then((res) => {
          this.isShowDoneExcel = false
          this.$Message.success({
            content: '操作成功',
          })
          this.$Spin.hide()
          window.luckysheet.destroy()
          this.$emit('closeExcel', true)
        })
        .catch((err) => {
          if (err) {
            this.isShowDoneExcel = false
            // this.$Message.error({
            //   content: err,
            // });
            this.$Spin.hide()
            return
          }
        })
    },
    Back() {
      window.luckysheet.destroy()
      if (
        this.bomStatus === this.$constDefinition.submitingTable ||
        this.bomStatus === this.$constDefinition.generatingTable
      ) {
        this.$emit('closeExcel', true)
      } else {
        this.$emit('closeExcel', false)
      }
    },
    //新老数据对比
    diffData(newData, oldData) {
      for (let i = 0; i < oldData.length; i++) {
        for (let j = 0; j < newData.length; j++) {
          if (oldData[i].id === newData[j].id) {
            for (let k in oldData[i]) {
              for (let n in newData[j]) {
                if (k === n) {
                  if (oldData[i][k] !== newData[j][k]) {
                    newData[j]['o' + k] = oldData[i][k]
                  }
                }
              }
            }
          }
        }
      }
      console.log(newData)
      return newData
    },
    //格式化数据前台展示
    formaterData(testdata) {
      let arr = []
      for (let k = 0; k < 31; k++) {
        let obj = {
          c: k,
          r: 0,
          v: {
            ct: {
              fa: 'General',
              t: 'g',
            },
            v: '',
            m: '',
            tb: 2, //换行
            bl: 1,
          },
        }
        if (k === 0) {
          obj.v.v = 'NO.'
          obj.v.m = 'NO.'
          obj.v.ht = 0
        }
        if (k === 1) {
          obj.v.v = '项目名称'
          obj.v.m = '项目名称'
        }
        if (k === 2) {
          obj.v.v = '订单号'
          obj.v.m = '订单号'
        }
        if (k === 3) {
          obj.v.v = '全名'
          obj.v.m = '全名'
        }
        if (k === 4) {
          obj.v.v = '物料材质'
          obj.v.m = '物料材质'
        }
        if (k === 5) {
          obj.v.v = '原料长度'
          obj.v.m = '原料长度'
        }
        if (k === 6) {
          obj.v.v = '原料宽度'
          obj.v.m = '原料宽度'
        }
        if (k === 7) {
          obj.v.v = '原料高度'
          obj.v.m = '原料高度'
        }
        if (k === 8) {
          obj.v.v = '原料直径'
          obj.v.m = '原料直径'
        }
        if (k === 9) {
          obj.v.v = '图号'
          obj.v.m = '图号'
        }
        if (k === 10) {
          obj.v.v = '需求数量'
          obj.v.m = '需求数量'
        }
        if (k === 11) {
          obj.v.v = '单位'
          obj.v.m = '单位'
        }
        if (k === 12) {
          obj.v.v = '重量/面积'
          obj.v.m = '重量/面积'
        }
        if (k === 13) {
          obj.v.v = '单价'
          obj.v.m = '单价'
        }
        if (k === 14) {
          obj.v.v = '工件费'
          obj.v.m = '工件费'
        }
        if (k === 15) {
          obj.v.v = '金额'
          obj.v.m = '金额'
        }
        if (k === 16) {
          obj.v.v = '承接厂商'
          obj.v.m = '承接厂商'
        }
        if (k === 17) {
          obj.v.v = '所属'
          obj.v.m = '所属'
        }
        if (k === 18) {
          obj.v.v = '类别1'
          obj.v.m = '类别1'
        }
        if (k === 19) {
          obj.v.v = '类别2'
          obj.v.m = '类别2'
        }
        if (k === 20) {
          obj.v.v = '类别3'
          obj.v.m = '类别3'
        }
        if (k === 21) {
          obj.v.v = '模具类型'
          obj.v.m = '模具类型'
        }
        if (k === 22) {
          obj.v.v = '客户名称'
          obj.v.m = '客户名称'
        }
        if (k === 23) {
          obj.v.v = '产线'
          obj.v.m = '产线'
        }
        if (k === 24) {
          obj.v.v = '受单日期'
          obj.v.m = '受单日期'
        }
        if (k === 25) {
          obj.v.v = '要求到厂日期'
          obj.v.m = '要求到厂日期'
        }
        if (k === 26) {
          obj.v.v = '实际到厂日期'
          obj.v.m = '实际到厂日期'
        }
        if (k === 27) {
          obj.v.v = '延误天数'
          obj.v.m = '延误天数'
        }
        // if(k === 28){
        //     obj.v.v = '状态'
        //     obj.v.m = '状态'
        // }
        if (k === 28) {
          obj.v.v = '负责人'
          obj.v.m = '负责人'
        }
        if (k === 29) {
          obj.v.v = 'id'
          obj.v.m = 'id'
        }
        // if (k === 30) {
        //   obj.v.v = "guid";
        //   obj.v.m = "guid";
        // }
        arr.push(obj)
      }
      for (let i = 0; i < testdata.length; i++) {
        for (let j = 0; j < 31; j++) {
          let obj = {
            c: j,
            r: i + 1,
            v: {
              ct: {
                fa: 'General',
                t: 'g',
              },
              //若没有使用公式则不要吧f设为空
              v: '',
              m: '',
              tb: 2, //换行
            },
          }
          if (j === 0) {
            obj.v.v = i + 1
            obj.v.m = i + 1
            obj.v.ht = 0
          }
          if (j === 1) {
            obj.v.v = testdata[i].c项目名称
            obj.v.m = testdata[i].c项目名称
            // 这里判断是否有修改
            if ('oc项目名称' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value:
                  '修改前：' + (testdata[i].oc项目名称 === null ? '' : testdata[i].oc项目名称 + ''),
                isshow: false,
              }
            }
          }
          if (j === 2) {
            obj.v.v = testdata[i].c订单号
            obj.v.m = testdata[i].c订单号
            if ('oc订单号' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value:
                  '修改前：' + (testdata[i].oc订单号 === null ? '' : testdata[i].oc订单号 + ''),
                isshow: false,
              }
            }
          }
          if (j === 3) {
            obj.v.v = testdata[i].c全名
            obj.v.m = testdata[i].c全名
            if ('oc全名' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value: '修改前：' + (testdata[i].oc全名 === null ? '' : testdata[i].oc全名 + ''),
                isshow: false,
              }
            }
          }
          if (j === 4) {
            obj.v.v = testdata[i].c物料材质
            obj.v.m = testdata[i].c物料材质
            if ('oc物料材质' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value:
                  '修改前：' + (testdata[i].oc物料材质 === null ? '' : testdata[i].oc物料材质 + ''),
                isshow: false,
              }
            }
          }
          if (j === 5) {
            obj.v.v = testdata[i].c原料长度
            obj.v.m = testdata[i].c原料长度
            // obj.v.ct.fa = '0.00'
            // obj.v.ct.t = 'n'
            if ('oc原料长度' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value:
                  '修改前：' + (testdata[i].oc原料长度 === null ? '' : testdata[i].oc原料长度 + ''),
                isshow: false,
              }
            }
          }
          if (j === 6) {
            obj.v.v = testdata[i].c原料宽度
            obj.v.m = testdata[i].c原料宽度
            // obj.v.ct.fa = '0.00'
            // obj.v.ct.t = 'n'
            if ('oc原料宽度' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value:
                  '修改前：' + (testdata[i].oc原料宽度 === null ? '' : testdata[i].oc原料宽度 + ''),
                isshow: false,
              }
            }
          }
          if (j === 7) {
            obj.v.v = testdata[i].c原料高度
            obj.v.m = testdata[i].c原料高度
            // obj.v.ct.fa = '0.00'
            // obj.v.ct.t = 'n'
            if ('oc原料高度' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value:
                  '修改前：' + (testdata[i].oc原料高度 === null ? '' : testdata[i].oc原料高度 + ''),
                isshow: false,
              }
            }
          }
          if (j === 8) {
            obj.v.v = testdata[i].c原料直径
            obj.v.m = testdata[i].c原料直径
            // obj.v.ct.fa = '0.00'
            // obj.v.ct.t = 'n'
            if ('oc原料直径' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value:
                  '修改前：' + (testdata[i].oc原料直径 === null ? '' : testdata[i].oc原料直径 + ''),
                isshow: false,
              }
            }
          }
          if (j === 9) {
            obj.v.v = testdata[i].c图号
            obj.v.m = testdata[i].c图号
            if ('oc图号' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value: '修改前：' + (testdata[i].oc图号 === null ? '' : testdata[i].oc图号 + ''),
                isshow: false,
              }
            }
          }
          if (j === 10) {
            obj.v.v = testdata[i].c数量
            obj.v.m = testdata[i].c数量
            // obj.v.ct.fa = '0'
            // obj.v.ct.t = 'n'
            if ('oc数量' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value: '修改前：' + (testdata[i].oc数量 === null ? '' : testdata[i].oc数量 + ''),
                isshow: false,
              }
            }
          }
          if (j === 11) {
            obj.v.v = testdata[i].c单位
            obj.v.m = testdata[i].c单位
            if ('oc单位' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value: '修改前：' + (testdata[i].oc单位 === null ? '' : testdata[i].oc单位 + ''),
                isshow: false,
              }
            }
          }
          if (j === 12) {
            obj.v.v = testdata[i].c重量or面积
            obj.v.m = testdata[i].c重量or面积
            // obj.v.ct.fa = '0.00'
            // obj.v.ct.t = 'n'
            if ('oc重量or面积' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value:
                  '修改前：' +
                  (testdata[i].oc重量or面积 === null ? '' : testdata[i].oc重量or面积 + ''),
                isshow: false,
              }
            }
          }
          if (j === 13) {
            obj.v.v = testdata[i].c单价
            obj.v.m = testdata[i].c单价
            if ('oc单价' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value: '修改前：' + (testdata[i].oc单价 === null ? '' : testdata[i].oc单价 + ''),
                isshow: false,
              }
            }
          }
          if (j === 14) {
            obj.v.v = testdata[i].c工件费
            obj.v.m = testdata[i].c工件费
            if ('oc工件费' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value:
                  '修改前：' + (testdata[i].oc工件费 === null ? '' : testdata[i].oc工件费 + ''),
                isshow: false,
              }
            }
          }
          if (j === 15) {
            obj.v.v = testdata[i].c金额
            obj.v.m = testdata[i].c金额
            // obj.v.ct.fa = '0.00'
            // obj.v.ct.t = 'n'
            if ('oc金额' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value: '修改前：' + (testdata[i].oc金额 === null ? '' : testdata[i].oc金额 + ''),
                isshow: false,
              }
            }
          }
          if (j === 16) {
            obj.v.v = testdata[i].supplierName
            obj.v.m = testdata[i].supplierName
            if ('osupplierName' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value:
                  '修改前：' +
                  (testdata[i].osupplierName === null ? '' : testdata[i].osupplierName + ''),
                isshow: false,
              }
            }
          }
          if (j === 17) {
            obj.v.v = testdata[i].c所属
            obj.v.m = testdata[i].c所属
            if ('oc所属' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value: '修改前：' + (testdata[i].oc所属 === null ? '' : testdata[i].oc所属 + ''),
                isshow: false,
              }
            }
          }
          if (j === 18) {
            obj.v.v = testdata[i].c类别1
            obj.v.m = testdata[i].c类别1
            if ('oc类别1' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value: '修改前：' + (testdata[i].oc类别1 === null ? '' : testdata[i].oc类别1 + ''),
                isshow: false,
              }
            }
          }
          if (j === 19) {
            obj.v.v = testdata[i].c类别2
            obj.v.m = testdata[i].c类别2
            if ('oc类别2' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value: '修改前：' + (testdata[i].oc类别2 === null ? '' : testdata[i].oc类别2 + ''),
                isshow: false,
              }
            }
          }
          if (j === 20) {
            obj.v.v = testdata[i].c类别3
            obj.v.m = testdata[i].c类别3
            if ('oc类别3' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value: '修改前：' + (testdata[i].oc类别3 === null ? '' : testdata[i].oc类别3 + ''),
                isshow: false,
              }
            }
          }
          if (j === 21) {
            obj.v.v = testdata[i].c模具类型
            obj.v.m = testdata[i].c模具类型
            if ('oc模具类型' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value:
                  '修改前：' + (testdata[i].oc模具类型 === null ? '' : testdata[i].oc模具类型 + ''),
                isshow: false,
              }
            }
          }
          if (j === 22) {
            obj.v.v = testdata[i].c客户名称
            obj.v.m = testdata[i].c客户名称
            if ('oc客户名称' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value:
                  '修改前：' + (testdata[i].oc客户名称 === null ? '' : testdata[i].oc客户名称 + ''),
                isshow: false,
              }
            }
          }
          if (j === 23) {
            obj.v.v = testdata[i].c产线
            obj.v.m = testdata[i].c产线
            if ('oc产线' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value: '修改前：' + (testdata[i].oc产线 === null ? '' : testdata[i].oc产线 + ''),
                isshow: false,
              }
            }
          }
          if (j === 24) {
            obj.v.v = testdata[i].c受单日期
              ? moment(testdata[i].c受单日期).format('YYYY-MM-DD')
              : ''
            obj.v.m = testdata[i].c受单日期
              ? moment(testdata[i].c受单日期).format('YYYY-MM-DD')
              : ''
            obj.v.ct.fa = 'yyyy-MM-dd'
            obj.v.ct.t = 'd'
            if ('oc受单日期' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value:
                  '修改前：' +
                  (testdata[i].oc受单日期 === null
                    ? ''
                    : moment(testdata[i].oc受单日期).format('YYYY-MM-DD') + ''),
                isshow: false,
              }
            }
          }
          if (j === 25) {
            obj.v.v = testdata[i].c要求到厂日期
              ? moment(testdata[i].c要求到厂日期).format('YYYY-MM-DD')
              : ''
            obj.v.m = testdata[i].c要求到厂日期
              ? moment(testdata[i].c要求到厂日期).format('YYYY-MM-DD')
              : ''
            obj.v.ct.fa = 'yyyy-MM-dd'
            obj.v.ct.t = 'd'
            if ('oc要求到厂日期' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value:
                  '修改前：' +
                  (testdata[i].oc要求到厂日期 === null
                    ? ''
                    : moment(testdata[i].oc要求到厂日期).format('YYYY-MM-DD') + ''),
                isshow: false,
              }
            }
          }
          if (j === 26) {
            obj.v.v = testdata[i].c实际到厂日期
              ? moment(testdata[i].c实际到厂日期).format('YYYY-MM-DD')
              : ''
            obj.v.m = testdata[i].c实际到厂日期
              ? moment(testdata[i].c实际到厂日期).format('YYYY-MM-DD')
              : ''
            obj.v.ct.fa = 'yyyy-MM-dd'
            obj.v.ct.t = 'd'
            if ('oc实际到厂日期' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value:
                  '修改前：' +
                  (testdata[i].oc实际到厂日期 === null
                    ? ''
                    : moment(testdata[i].oc实际到厂日期).format('YYYY-MM-DD') + ''),
                isshow: false,
              }
            }
          }
          if (j === 27) {
            obj.v.v = testdata[i].c延误天数
            obj.v.m = testdata[i].c延误天数
            obj.v.fc = testdata[i].c延误天数 > 0 ? '#ff1f1d' : '#438b3f'
            if ('oc延误天数' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value:
                  '修改前：' + (testdata[i].oc延误天数 === null ? '' : testdata[i].oc延误天数 + ''),
                isshow: false,
              }
            }
          }
          if (j === 28) {
            obj.v.v = testdata[i].c采购负责人姓名
            obj.v.m = testdata[i].c采购负责人姓名
            if ('oc采购负责人姓名' in testdata[i]) {
              obj.v.ps = {
                left: 0,
                top: 0,
                width: 10,
                height: 20,
                value:
                  '修改前：' +
                  (testdata[i].oc采购负责人姓名 === null ? '' : testdata[i].oc采购负责人姓名 + ''),
                isshow: false,
              }
            }
          }
          if (j === 29) {
            obj.v.v = testdata[i].id
            obj.v.m = testdata[i].id
          }
          // if (j === 30) {
          //   obj.v.v = testdata[i].guid;
          //   obj.v.m = testdata[i].guid;
          // }
          arr.push(obj)
        }
      }
      return arr
    },
    //格式化数据发送给后台
    formaterSendData(params) {
      let arr = []
      for (var i = 0; i < params.length / 31; i++) {
        let obj = {
          id: '',
          c项目名称: '',
          c订单号: '',
          c全名: '',
          c物料材质: '',
          c原料长度: '',
          c原料宽度: '',
          c原料高度: '',
          c原料直径: '',
          c图号: '',
          c数量: '',
          c单位: '',
          c重量or面积: '',
          c单价: '',
          c工件费: '',
          c金额: '',
          supplierName: '',
          c所属: '',
          c类别1: '',
          c类别2: '',
          c类别3: '',
          c模具类型: '',
          c客户名称: '',
          c产线: '',
          c受单日期: '',
          c要求到厂日期: '',
          c实际到厂日期: '',
          c延误天数: '',
          c采购负责人姓名: '',
          bOMImportRecordId: this.id,
        }
        for (var j = i * 31; j < (i + 1) * 31; j++) {
          if (i > 0) {
            // if(params[j].v.v === undefined){
            //     params[j].v.v = ''
            // }
            if (j === i * 31 + 1) {
              obj.c项目名称 = params[j].v.v
            }
            if (j === i * 31 + 2) {
              obj.c订单号 = params[j].v.v
            }
            if (j === i * 31 + 3) {
              obj.c全名 = params[j].v.v
            }
            if (j === i * 31 + 4) {
              obj.c物料材质 = params[j].v.v
            }
            if (j === i * 31 + 5) {
              obj.c原料长度 = params[j].v.v
            }
            if (j === i * 31 + 6) {
              obj.c原料宽度 = params[j].v.v
            }
            if (j === i * 31 + 7) {
              obj.c原料高度 = params[j].v.v
            }
            if (j === i * 31 + 8) {
              obj.c原料直径 = params[j].v.v
            }
            if (j === i * 31 + 9) {
              obj.c图号 = params[j].v.v
            }
            if (j === i * 31 + 10) {
              obj.c数量 = params[j].v.v
            }
            if (j === i * 31 + 11) {
              obj.c单位 = params[j].v.v
            }
            if (j === i * 31 + 12) {
              obj.c重量or面积 = params[j].v.v
            }
            if (j === i * 31 + 13) {
              obj.c单价 = params[j].v.v
            }
            if (j === i * 31 + 14) {
              obj.c工件费 = params[j].v.v
            }
            if (j === i * 31 + 15) {
              obj.c金额 = params[j].v.v
            }
            if (j === i * 31 + 16) {
              obj.supplierName = params[j].v.v
            }
            if (j === i * 31 + 17) {
              obj.c所属 = params[j].v.v
            }
            if (j === i * 31 + 18) {
              obj.c类别1 = params[j].v.v
            }
            if (j === i * 31 + 19) {
              obj.c类别2 = params[j].v.v
            }
            if (j === i * 31 + 20) {
              obj.c类别3 = params[j].v.v
            }
            if (j === i * 31 + 21) {
              obj.c模具类型 = params[j].v.v
            }
            if (j === i * 31 + 22) {
              obj.c客户名称 = params[j].v.v
            }
            if (j === i * 31 + 23) {
              obj.c产线 = params[j].v.v
            }
            if (j === i * 31 + 24) {
              obj.c受单日期 = params[j].v.m
            }
            if (j === i * 31 + 25) {
              obj.c要求到厂日期 = params[j].v.m
            }
            if (j === i * 31 + 26) {
              obj.c实际到厂日期 = params[j].v.m
            }
            if (j === i * 31 + 27) {
              obj.c延误天数 = params[j].v.v
            }
            if (j === i * 31 + 28) {
              obj.c采购负责人姓名 = params[j].v.v
            }
            if (j === i * 31 + 29) {
              obj.id = params[j].v.v
            }
          }
        }
        if (i > 0) {
          arr.push(obj)
        }
      }
      return arr
    },
  },
}
</script>

<style lang="less" scoped>
// @import url('https://cdn.jsdelivr.net/npm/luckysheet/dist/plugins/css/pluginsCss.css');
// @import url('https://cdn.jsdelivr.net/npm/luckysheet/dist/plugins/plugins.css');
// @import url('https://cdn.jsdelivr.net/npm/luckysheet/dist/css/luckysheet.css');
// @import url('https://cdn.jsdelivr.net/npm/luckysheet/dist/assets/iconfont/iconfont.css');

* {
  margin: 0;
  padding: 0;
}

.luckysheet-content {
  margin: 0px;
  padding: 0px;
  position: absolute;
  width: 98%;
  height: 654px;
  left: 20px;
  top: 40px;
  bottom: 0px;
  min-width: 1260px;
}

.header {
  display: flex;
  height: 30px;
  width: 98%;
  line-height: 30px;
  align-items: center;
  justify-content: center;
  position: absolute;
  min-height: 0;
  top: 760px;
  text-align: center;
}

.ivu-btn {
  width: 60px;
  height: 30px;
  line-height: 30px;
}

.printHideCss {
  visibility: hidden !important;
}
.excelContent {
  // position: relative;
  width: 100%;
  min-width: 1260px;
}
// /deep/.luckysheet-cols-h-cells {
//     display: none !important;
// }

// /deep/.luckysheet-modal-dialog {
//     width: 100px !important;
//     padding: 0 !important;
// }

.content {
  text-align: center;
  font-size: 16px;
}

.footer {
  text-align: center;
}

.modal-cont /deep/ .ivu-modal-body {
  font-size: 20px;
  text-align: center;
}
.modal-cont /deep/ .ivu-modal {
  top: 300px;
}
</style>
